import React from 'react';
import { FormattedMessage } from 'react-intl';
import { func, string, shape, arrayOf, any } from 'prop-types';
import classnames from 'classnames';
import Pastille from '../Pastille/Pastille';

export default function PromotedFiltersSummary({
    className,
    pastilles,
    onSelectPastille,
}) {
    const rootClassnames = classnames('promoted-filters-summary', className);

    return (
        <div className={rootClassnames}>
            <h1 className="promoted-filters-summary__title">
                <span>
                    <FormattedMessage
                        id="listing.promotedFilters.summaryTitle"
                        description="PromotedFilters summary title"
                        defaultMessage="Your selection"
                    />
                </span>
            </h1>

            <div className="promoted-filters-summary__pastilles">
                {pastilles.map(pastille => (
                    <Pastille
                        key={pastille.id}
                        {...pastille}
                        active
                        onSelectPastille={onSelectPastille}
                    />
                ))}
            </div>
        </div>
    );
}

PromotedFiltersSummary.propTypes = {
    className: string,
    pastilles: arrayOf(
        shape({
            attributes: arrayOf(
                shape({
                    key: string,
                    value: any,
                    type: string,
                    operator: string,
                }),
            ),
        }),
    ).isRequired,
    onSelectPastille: func.isRequired,
};

PromotedFiltersSummary.defaultProps = {
    className: null,
};
